import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { BuilderContextProvidersSiteConfig, ContextProviderRegistry } from './types'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'

export const BuilderContextProvidersRegistry = withDependencies(
	[named(SiteFeatureConfigSymbol, name)],
	(siteFeatureConfig: BuilderContextProvidersSiteConfig): ContextProviderRegistry => {
		const registry: { [contextType: string]: any } = {}
		return {
			registerContextProvider: (contextType: string, contextProviderModule: any) => {
				registry[contextType] = contextProviderModule
			},
			getContextProvider: (contextType: string) => {
				return registry[contextType]
			},
			getUseContextHook: (contextType: string) => {
				const contextConfig = siteFeatureConfig.contextProviders[contextType]
				if (!contextConfig) {
					throw new Error(
						`[ContextBindingWrapper] Context provider "${contextType}" is not configured. ` +
							`Available providers: [${Object.keys(siteFeatureConfig.contextProviders).join(', ')}]`
					)
				}

				const hookAccessor = contextConfig.contextSpecifier?.hook
				if (!hookAccessor) {
					throw new Error(
						`[ContextBindingWrapper] Context provider "${contextType}" is missing contextSpecifier.hook configuration`
					)
				}

				const module = registry[contextType]
				if (!module) {
					throw new Error(
						`[ContextBindingWrapper] Context provider "${contextType}" module is not loaded. ` +
							`Did retrieveContextProviders() complete before rendering?`
					)
				}

				const hook = module[hookAccessor]
				if (typeof hook !== 'function') {
					throw new Error(
						`[ContextBindingWrapper] Context provider "${contextType}" module does not export hook "${hookAccessor}". ` +
							`Available exports: [${Object.keys(module).join(', ')}]`
					)
				}

				return hook
			},
		}
	}
)
